<template>
  <div class="email-box">
    <b-tabs>
      <b-tab-item label="基本設定" class="tab-email-box">
        <div class="option-box">
          <p>送信元</p>
          <input class="input is-small" placeholder="例：HR monster" v-model="scenarioEdit.parameter.from"
          :disabled="scenarioEdit.is_confirm"/>
        </div>
        <div class="option-box">
          <p>TEL</p>
          <input class="input is-small" placeholder="例：08012345678" v-model="scenarioEdit.parameter.to"
          :disabled="scenarioEdit.is_confirm"/>
        </div>
        <p class="content-title"><span class="mdi mdi-circle-edit-outline -right-8px"></span>ショートメッセージの内容を入力してください。</p>
        <textarea class="textarea input disp-scroll" maxlength="670" v-model="scenarioEdit.mainmessage"
        :disabled="scenarioEdit.is_confirm"></textarea>
        <p class="comment">(※1) ハイフンなしの番号を入力して下さい。</p>
        <p class="comment">(※2) 日本国外の場合は「+」から始まる国コードを入力して下さい。</p>
        <p class="comment">(※3) 送付内容は670文字以内でお願いいたします。</p>
        <p class="comment">(※4) 送信元は入力がない場合はHRmonsterからの送付となります。半角英数字のみ11文字以内でお願いいたします。</p>
        <p class="comment">(※5) __date_modify__と本文に入力すると日程自動調整で日程調整された訪問者向けの日程変更リンクに変換されます。</p>
      </b-tab-item>
      <b-tab-item label="アフターフォロー設定" class="tab-email-box">
        <div class="tab-box-form">
          <div class="tab-box-left">
            <p style="text-align: left;">
              <b>送付スケジュール</b>
              <br>
            </p>
          </div>
          <div class="tab-box-right">
            <b-numberinput
              size="is-small"
              style="width: 100px;"
              :editable="false"
              v-model="scenarioEdit.parameter.after"
              min="0" max="90" controls-position="compact"
              :disabled="scenarioEdit.is_confirm">
            </b-numberinput>日後
          </div>
        </div>
        <div v-if="scenarioEdit.parameter.after" class="tab-box-form">
          <div class="tab-box-left">
            <p style="text-align: left;">
              <b>即日送付</b>
              <br>
              <span style="color: #666; font-size: 12px;">
                ONにするとアフターフォローとは別に即日送付されます。
              </span>
            </p>
          </div>
          <div class="tab-box-right">
            <b-switch 
              style="width: 100%;"
              v-model="scenarioEdit.parameter.is_same_day"
              :disabled="scenarioEdit.is_confirm"
            >
            </b-switch>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.email-box {
  background: #ffffff;
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 8px;
  background-color:white;
  .tab-email-box {
    padding: 8px;
    padding-top: 16px;
  }
  .option-box {
    display: flex;
    margin: 8px 0;
    p {
      text-align: left;
      font-weight: bold;
      width: 64px;
    }
    input {
      width: calc(100% - 64px);
    }
  }
  .content-title {
    text-align: left;
    font-weight: bold;
  }
  .comment {
    text-align: left;
    color: grey;
    font-size: 13px;
  }
  .tab-box::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
  }
  .tab-box-form {
    width: 100%; display: flex; padding: 8px;
  }
  .tab-box-left {
    width: 40%; display: flex; justify-content: flex-start; align-items: center;
  }
  .tab-box-right {
    width: 60%;
    font-size: 13px;
    padding: 10px;
    justify-content: flex-start;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditSMSParts.vue